import React from "react";

export const SOCIAL_NETWORKS = [
  {
    id: "vk",
    name: "VK",
    color: "bg-[#0077FF]",
    buildHref: (url, text) =>
      `https://vk.com/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(text)}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
        <path d="M21.55 6.36c.14-.46 0-.8-.68-.8h-2.24c-.57 0-.83.3-.97.63 0 0-1.14 2.78-2.76 4.58-.52.52-.76.68-1.04.68-.14 0-.36-.16-.36-.62V6.36c0-.55-.15-.8-.62-.8H9.1c-.35 0-.55.26-.55.5 0 .52.79.64.87 2.08v3.14c0 .68-.12.8-.38.8-.68 0-2.33-2.79-3.3-5.96-.2-.58-.4-.82-.96-.82H2.54c-.6 0-.72.3-.72.63 0 .6.68 3.56 3.56 7.48C7.13 18.17 9.9 19.5 12 19.5c1.17 0 1.32-.26 1.32-.82v-1.9c0-.59.12-.7.54-.7.31 0 .84.16 2.08 1.37 1.42 1.42 1.66 2.06 2.46 2.06h2.24c.6 0 .9-.26.73-.83-.19-.57-.86-1.4-1.75-2.38-.48-.56-1.2-1.17-1.42-1.47-.31-.4-.22-.57 0-.92 0 0 2.5-3.53 2.76-4.73Z" />
      </svg>
    ),
  },
  {
    id: "ok",
    name: "Одноклассники",
    color: "bg-[#EE8208]",
    buildHref: (url, text) =>
      `https://connect.ok.ru/offer?url=${encodeURIComponent(url)}&title=${encodeURIComponent(text)}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
        <path d="M12 2.25a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 0 0 0-11.5Zm0 8.27a2.52 2.52 0 1 1 0-5.04 2.52 2.52 0 0 1 0 5.04Zm4.2 4.65a1.41 1.41 0 0 0-1.99.01A6.4 6.4 0 0 1 12 16.4a6.4 6.4 0 0 1-2.21-.22 1.41 1.41 0 0 0-1.99-.01 1.39 1.39 0 0 0 0 1.97 8.25 8.25 0 0 0 1.98 1.23l-2.36 2.35a1.4 1.4 0 1 0 1.98 1.98L12 20.62l2.61 2.61a1.4 1.4 0 0 0 1.98-1.98l-2.36-2.35a8.25 8.25 0 0 0 1.98-1.23 1.39 1.39 0 0 0-.01-1.97Z" />
      </svg>
    ),
  },
  {
    id: "tg",
    name: "Телеграм",
    color: "bg-[#0088CC]",
    buildHref: (url, text) =>
      `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
        <path d="M21.94 4.6a1.37 1.37 0 0 0-1.52-.22L3.6 12.2a1.35 1.35 0 0 0 .09 2.47l3.69 1.42 1.43 4.52c.18.58.68.95 1.25.95h.02c.55-.01 1.04-.36 1.22-.9l1.56-4.63 4.88 4.21a1.36 1.36 0 0 0 2.24-.78l2.14-13.4c.08-.48-.13-.96-.48-1.16ZM9.17 17.46l-.74-2.34 6.59-4.13-4.64 5.68c-.06.08-.14.19-.21.3Zm1.61 3.01ZM18.6 18.4l-4.73-4.08 6.17-7.54-1.44 9.2Z" />
      </svg>
    ),
  },
];

export default SOCIAL_NETWORKS;
